import { EndpointCardCombinedProps } from './types';

const usePresenter = (props: EndpointCardCombinedProps): EndpointCardCombinedProps => {
  return props;
};

export default usePresenter;
